<template>
  <div id="app">
    <router-view />
    <Tabbar v-if="isPc"/>
  </div>
</template>
<script>
import { initConfig, AppUpdata } from '@/api/index.js'
import { JpushUtil, jpush } from '@/utils/jpush'
import Appup from '@/components/updata/index.js'
import Tabbar from '@/components/tabbar'

export default {
  name: 'App',
  components: {
    [Tabbar.name]: Tabbar
  },
  data() {
    return {
    	isPc:null,
    }
  },
  created() {
	  this.isPc = navigator.userAgent.match(
      /(phone|pad|pod|iphone|ipod|ios|iPad|Android|Mobild|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|webOS|Symbian|Windows Phone)/i
    )
    // 修改配置
    // initConfig({ paramAscription: 'psys' }).then(res => {
    //   if (res.code === 0) {
    //     this.$store.commit('SET_PICSRC', res.data.picsrc)
    //   }
    // })
    // 升级
    // AppUpdata().then(res => {
    //   if (res.code !== 0) return
    //   if (res.version.versionNo > this.$store.state.versionNo) {
    //     Appup({
    //       url: res.version.appUrl,
    //       versionNo: res.version.versionNo,
    //       isForce: res.version.isForce
    //     })
    //   }
    // })
  },
  mounted() {
    const cordova = document.getElementById('cordova')
    if (cordova || !this.$store.state.ismode) return
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = './cordova.js'
    script.id = 'cordova'
    document.body.appendChild(script)
    // 极光
    jpush()
    new JpushUtil().initPush()
  }
}
</script>
<style>
body {
  font-size: 16px;
  background-color: #f8f8f8;

  -webkit-font-smoothing: antialiased;
 
}
*{
  padding: 0;
  margin:0;
}

</style>
